<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c2c2c;
  overflow: hidden;
  width: 375px;
  margin: auto;
}
</style>

// 钱包列表
// 优惠券
// 积分
// 我的司机
// 客服
// 关于我们
// 隐私条款
// 用户协议
// 收费标准

